"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montese": {
    "d48139e1": [{
      "hkey": "8e254976",
      "slug": "montese",
      "name": "Montese",
      "primary": true,
      "skipSearch": false
    }],
    "bertocchi": [{
      "hkey": "8e254976",
      "slug": "montese",
      "name": "Montese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3afc6782": [{
      "hkey": "f460481b",
      "slug": "castelluccio",
      "name": "Castelluccio",
      "primary": true,
      "skipSearch": false
    }],
    "castelluccio-di-moscheda": [{
      "hkey": "f460481b",
      "slug": "castelluccio",
      "name": "Castelluccio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a2da80cf": [{
      "hkey": "927b7952",
      "slug": "montalto-lastrelle",
      "name": "Montalto Lastrelle",
      "primary": true,
      "skipSearch": false
    }],
    "montalto": [{
      "hkey": "927b7952",
      "slug": "montalto-lastrelle",
      "name": "Montalto Lastrelle",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1d2ee31e": [{
      "hkey": "8e254976",
      "slug": "montese",
      "name": "Montese",
      "primary": true,
      "skipSearch": false
    }],
    "montespecchio": [{
      "hkey": "8e254976",
      "slug": "montese",
      "name": "Montese",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;